<div class="flex align-items-center justify-content-center">
    <img alt="image" [ngStyle]="fields.uiOptions?.headerImageStyle" src="./assets/media/icons/mail.png" />
</div>
<div class="text-center mb-2">
    <h3 class="text-lg font-semibold text-gray-900 mb-5">
        {{fields.properties?.subHeaderText}}
    </h3>
    <div class="flex flex-col">
        <span class="text-2sm text-gray-600 font-medium mb-1.5" *ngIf="fields.properties?.headerText">
            {{fields.properties?.headerText}}
        </span>
        <span class="text-2sm text-gray-600 font-medium mb-1.5" *ngIf="!fields.properties?.headerText">
            Enter the verification code we sent to
        </span>

        <a class="text-sm font-semibold text-gray-900 mb-2"
            *ngIf="workflowData?.nodes[0]?.previousData.email && !fields.properties?.highlightedText">
            {{workflowData?.nodes[0]?.previousData.email}}
        </a>
        <a class="text-sm font-semibold text-gray-900 mb-2"
            *ngIf="workflowData?.nodes[0]?.previousData.email && fields.properties?.highlightedText">
            {{fields.properties?.highlightedText}}
        </a>
    </div>
</div>